import React, { Component} from 'react';
import './News.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class News extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
    this.constructNews = this.constructNews.bind(this);
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
    
  }

  constructNews(){
    let res = []
    this.props.news.forEach((news) => {
      res.push(
        <div>
            <div id = "newsDateBlock"> {news.type}</div>
            <div id = "newsNewsBlock"> <strong>{news.date}</strong>  {" | " + news.content} </div>
        </div>
      )

    });
    return res;
  }



  render() {
    return (
      <div className = "newsPage newsScrollableSec fadeNewsAnimation">
        <div className = "newsHeader">
        </div>
        <div className = "newsContent1">
          
          <h3> Lab News and Updates </h3>
          {this.constructNews()}
        </div>


      </div>
    )
  }
}

export default News;
